import React from "react";
import { Box } from "@mui/material";
import { AnnualWheelPriority } from "../annualWheelDialog/AnnualWheelDialog.types";
import { highRiskIcon, lowRiskIcon, moderateRiskIcon, reallyHighRiskIcon, reallyLowRiskIcon } from "../../riskAssessment/riskIndicator/riskIcons";

interface AnnualWheelPriorityIconProps {
    priority: AnnualWheelPriority;
    priorityString: string;
}

const AnnualWheelPriorityIcon: React.FC<AnnualWheelPriorityIconProps> = ({ priority, priorityString }) => {
    const getPriorityIcon = (priority: AnnualWheelPriority) => {
        switch (priority) {
            case AnnualWheelPriority.VeryLow:
                return reallyLowRiskIcon;
            case AnnualWheelPriority.Low:
                return lowRiskIcon;
            case AnnualWheelPriority.Moderate:
                return moderateRiskIcon;
            case AnnualWheelPriority.High:
                return highRiskIcon;
            case AnnualWheelPriority.VeryHigh:
                return reallyHighRiskIcon;
        }
    };

    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {getPriorityIcon(priority)} {priorityString}
        </Box>
    );
};

export default AnnualWheelPriorityIcon;
